import { useQuery } from '@tanstack/react-query'
import { healthApi } from '../services/birdbrain-api-client'

export type {
  HealthAlert,
  HealthHeroDay,
  HealthStatus,
  HealthSummaryResponse,
} from '../services/birdbrain-api-client'

/**
 * System health summary: overall status, actionable alerts, freshness rollup,
 * SocialKit reel-queue state, and the Home hero daily series. The probe fans
 * out ~30 BigQuery reads server-side, so refresh matches the freshness page
 * cadence (5 min), not the live-ops one.
 */
export function useHealthSummary() {
  const query = useQuery({
    queryKey: ['health', 'summary'],
    queryFn: () => healthApi.getSummary(),
    refetchInterval: 5 * 60 * 1000,
    // Server-side this fans out a full probe — mounts/refocus within the
    // refresh window serve cache instead of re-triggering it.
    staleTime: 5 * 60 * 1000,
  })
  return {
    data: query.data ?? null,
    loading: query.isPending,
    refreshing: query.isFetching && !query.isPending,
    error: query.error,
    refetch: query.refetch,
    updatedAt: query.dataUpdatedAt ? new Date(query.dataUpdatedAt) : null,
  }
}
